import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store'
import Dashboard from '../views/Dashboard.vue'
import Infos from '../views/Infos.vue'
import Course from '../views/Course.vue'
import HomeExercise from '../views/HomeExercise.vue'
import Result from '../views/Result.vue'
import Question from '../views/Question.vue'
import Login from '../views/Login.vue'
import Navbar from '../components/Navbar.vue'
import ConfirmEmail from '../views/ConfirmEmail.vue'
import ForgottenPassword from '../views/ForgottenPassword.vue'
import ResettingPassword from '../views/ResettingPassword.vue'
import Certificate from '../views/Certificate.vue'
import ProfilFormation from '../views/ProfilFormation.vue'

Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
  if (Store.getters.isAuthenticated()) {
    next()
    return
  } else {
    next({ name: 'Login' })
  }
}

const ifNotAuthenticated = (to, from, next) => {
  if (!Store.getters.isAuthenticated()) {
    next()
    return
  } else {
    next({ name: 'Dashboard' })
  }
}

const routes = [
  {
    path: '/confirmation-email/:user?/:token?',
    name: 'Confirmation de la nouvelle adresse email',
    component: ConfirmEmail,
    meta: {
      title: "Confirmation de la nouvelle adresse email"
    }
  },
  {
    path: '/forgotten-password/',
    name: 'ForgottenPassword',
    component: ForgottenPassword,
    meta: {
      title: "Mot de passe oublié"
    }
  },
  {
    path: '/resetting/:user?/:token?',
    name: 'ResettingPassword',
    component: ResettingPassword,
    meta: {
      title: "Réinitialiser le mot de passe"
    }
  },
  {
    path: '/certificate/:user?',
    name: 'Certificate',
    component: Certificate,
    meta: {
      title: "Certificat"
    }
  },
  {
    path: '/plus/certificate/:user?',
    name: 'DcplusCertificate',
    component: Certificate,
    meta: {
      title: "Certificat Plus"
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifNotAuthenticated,
    meta: {
      title: "Connexion"
    }
  },
  {
    path: '/',
    component: Navbar,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          title: "Tableau de bord"
        }
      },
      {
        path: '/infos',
        name: 'Infos',
        component: Infos,
        meta: {
          title: "Informations personnelles"
        }
      },
      {
        path: '/course/:moduleId/:chapterId?',
        name: 'Course',
        component: Course,
        meta: {
          title: "Support de formation"
        }
      },
      {
        path: '/exercise/:id',
        name: 'HomeExercise',
        component: HomeExercise,
        props: true,
        meta: {
          title: "Accueil exercice"
        }
      },
      {
        path: '/question/:id',
        name: 'Question',
        component: Question,
        meta: {
          title: "Question"
        }
      },
      {
        path: '/result/:id',
        name: 'Result',
        component: Result,
        meta: {
          title: "Résultats"
        }
      },
      {
        path: '/profil_formation',
        name: 'ProfilFormation',
        component: ProfilFormation,
        meta: {
          title: "Profil formation"
        }
      },
      {
        path: '/suivi_professionnel',
        name: 'SuiviProfessionnel',
        component: ProfilFormation,
        meta: {
          title: "Suivi professionnel"
        }
      },
      {
        path: '*',
        name: 'NotFound',
        beforeEnter: ifNotAuthenticated,
        meta: {
          title: "Page introuvable"
        }
      }
    ],
    beforeEnter: ifAuthenticated
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = 'Digital Citizen - '+to.meta.title
  next()
})

export default router
